<template>
    <div class="search_result" v-loading="loading">
        <div class="inner">
            <div class="search_course" v-if="openCourse.length>0">
                <div class="title">公开课</div>
                <div class="course_list">
                    <cursordetail 
                    class="cursor_item" 
                    v-for="(item,index) in openCourse" 
                    @setHandleDetail="openclass"
                    @setEqual="getEqual" 
                    :cursorDetail="item" 
                    :d-height="dHeight"
                    :key="index" />
                </div>
            </div>
            <div class="search_course" v-if="privacyCourse.length>0">
                <div class="title">培训课程</div>
                <div class="course_list">
                    <cursordetail 
                    class="cursor_item" 
                    v-for="(item,index) in privacyCourse" 
                    @setHandleDetail="getHandleDetail" 
                    @setEqual="getEqual"
                    :cursorDetail="item" 
                    :key="index"
                    :d-height="dHeight" />
                </div>
            </div>
            <el-empty v-if="openCourse.length==0&&privacyCourse.length==0" class="empty" description="暂无搜索内容"></el-empty>
        </div>
    </div>
</template>
<script>
// 事件总线
import bus from '@/utils/bus'
import Cursordetail from "@/components/Cursordetail"
import {listCourseByTitle} from '@/api/coursedetails'
export default {
    name:'SearchResult',
    components:{
        Cursordetail
    },
    data(){
        return {
            openCourse:[],
            privacyCourse:[],
            loading:false,
            dHeight:0
        }
    },
    created(){
        var search = ''
        if(this.$route.params.id){
            search = this.$route.params.id
        }
        this.listCourseByTitle(search)
    },
    mounted(){
        var that = this
        bus.$on('setSearch',function(data){
            that.listCourseByTitle(data)
        })
    },
    methods:{
        listCourseByTitle(search){
            this.loading = true
            listCourseByTitle(search).then(res=>{
                console.log(res)
                this.loading = false
                var data = res.data
                this.openCourse = data[0]
                this.privacyCourse = data[1].map(v=>{
                    return {
                    cover: v.cover,
                    createId: v.createId,
                    createTime: v.createTime,
                    description: v.description,
                    id: v.id,
                    teacherName: v.teacherName,
                    title: v.title,
                    updateId: v.updateId,
                    updateTime: v.updateTime,
                    classHours:v.classHours?(v.classHours/60/45)==0?'0':(v.classHours/60/45).toFixed(2):''
                    }
                })
                console.log(this.privacyCourse)
            }).catch(()=>{
                this.loading = false
            })
        },
        getHandleDetail(data){
            let rourl =  this.$router.resolve({path:"/coursedetails",query:{id:data.id,professionId:data.professionId}});
            window.open(rourl.href);
        },
        openclass(data){
            let rourl =  this.$router.resolve({path:"/openclass",query:{id:data.id}});
            window.open(rourl.href);
        },
        getEqual(h){
            this.dHeight = (this.dHeight<h?h:this.dHeight)
        }
    }
}
</script>
<style lang="scss" scoped>
.search_result{
    min-height: 600px;
    background: #fff;
    padding-top: 40px;
    .empty{
        padding-top: 180px;
    }
    .title{
        font-size: 30px;
        font-weight: bold;
        color: #333333;
        margin-bottom:35px;
    }
    .course_list {
        display: flex;
        flex-wrap: wrap;
        margin-left: -13px;
        margin-right: -13px;
        .cursor_item{
            width: 33.33%;
        }
    }
}
</style>